import { Permission, User } from "../types";

export const services = {
    users: "users",
    deliveryBoy : "deliveryBoy",
    createOrder : "createOrder",
    products : "products",
    customers : "customers",
    orders : "orders",
    draftOrder : "draftOrder",
    cancels : "cancelOrder",
    returns : "returnOrder",
    refunds : "refundOrder",
    updatePricing : "updatePricing",
    reportService : "reportService",
    uploadImages : "uploadImages",
    inventory : "inventory",
    inventoryView : "inventoryView",
    inventoryMove : "inventoryMove",
    inventoryAdjustments : "inventoryAdjustments",
    skuToQRC : "skuToQrcodeBarcode",
    blog : "blog",
    uploadOthersMaster : "uploadOthersMaster",
    dispatch : "orderDispatches",
    draftPurchaseOrders : "draftPurchaseOrders",
    purchaseOrders : "purchaseOrders",
    createPurchaseOrder : "createPurchaseOrder",
    inboundPurchaseOrders : "inboundPurchaseOrders",
    inwardPurchaseOrders : "inwardPurchaseOrders",
    orderAllocation : 'orderAllocations',  
    sellers : "sellers",
    bin : "bins",
    inwardReturns : "inwardReturns",
    deliveryShipping : "deliveryShipping",
    pushNotifications : "pushNotifications",
    picklists : "picklists",
    packing : "packing",
    fieldSales : "fieldSales",
    salesManager : 'salesManager',
    scheme : "scheme",
    skuTransactions : "skuTransactions",
    locations : "locations",
    affiliates : "affiliates",
    commissions : "commissions",
    createCommission : "createCommission",
    affiliateCommissions : "affiliateCommissions",
    estimates : "estimates",
    franchise : "franchise",
    specialRetailer : "specialRetailer",
    settings : "settings",
    discountSetting : "discountSetting",
    pincodeSetting : "pincodeSetting",
    franchiseOwner: "franchiseOwner",
    notificationSetting : "notificationSetting",
    statesSettings : "statesSettings",
    lowInventoryTracker: "lowInventoryTracker",
}

export const permission = {
    create : "create",
    read : "read",
    update : "update",
    delete : "delete"
}

export const CheckRoleBasedPermission = (userData: User | null, serviceName: (typeof services)[keyof typeof services], permissionName: (typeof permission)[keyof typeof permission]) => {
    let isAuthorized = false;
    if (!userData) {
        return false;
    }
    let isUserHaveGivenService = userData?.services?.find(service => service?.name === serviceName);
    if (isUserHaveGivenService) {
        isAuthorized = isUserHaveGivenService.permissions.includes(permissionName);
        const franchises = userData?.locations?.filter((loc) => loc.startsWith('L-FR'));
        if (
            franchises?.length !== 0 &&
            !["super-admin", "admin"].includes(userData?.role) &&
            !['inventoryView', 'inventory']?.includes(serviceName) &&
            userData?.services?.find(service => service.name === 'blockedFromPortal')
        ) {
            isAuthorized = false;
        }
    }
    return isAuthorized || ["super-admin", "admin"].includes(userData?.role);
}